<template>
  <v-container fluid align-start ma-0 pa-2 class="epms5070-main container-height">
    <v-row no-gutters class="h-full">
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
          class="h-full"
          :useBtnList="useBtnList"
          :customBtnList="customBtnList"
          @btnRetrieve="btnRetrieve"
          @btnContract="btnContract"
          @btnMaterialList="btnMaterialList"
          @btnInvoice="btnInvoice"
          @btnPackingList="btnPackingList"
          @btnInvPackList="btnInvPackList"
          @btnToExcel="btnToExcel"
          @btnToExcelNew="btnToExcelNew"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-select
                          v-model="selectShipNo"
                          :items="shipNoList"
                          return-object
                          item-text="shipNo"
                          item-value="shipNo"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>

                      <i-label :label="'Payment Div :'" class="pl-2" />
                      <v-col cols="1">
                        <v-select
                          v-model="selectPayDiv"
                          :items="payDivList"
                          return-object
                          item-text="codeName"
                          item-value="code"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>

                      <i-label :label="'Warehouse Div :'" class="pl-2" />
                      <v-col cols="1">
                        <v-select
                          v-model="selectWhDiv"
                          :items="whDivList"
                          return-object
                          item-text="codeName"
                          item-value="code"
                          single-line
                          outlined
                          dense
                          height="32" />
                      </v-col>
                      
                      <i-label :label="'Warehouse Duration :'" class="pl-2" />
                      <v-col cols="1">
                        <DxDateBox
                          :value="stDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                      <span class="px-2 d-flex align-center text-h6"> ~ </span>
                      <v-col cols="1">
                        <DxDateBox
                          :value="edDte"
                          height="32px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {edDte = e.value && getStrFormat(e.value)}"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col cols="5">
                <DxDataGrid
                  class="listBox"
                  :ref="epms5070Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width="grid.width"
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
                  @cellClick="cellClick"
                  @cellPrepared="cellPrepared"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />
                  <DxColumn data-field="invoiceNo" caption="Invoice No" alignment="center" :allow-editing="false"
                                        cell-template="invoiceNoCellTmpl" />
                  <template #invoiceNoCellTmpl="{ data: cellInfo }">
                    {{ cellInfo.data.seq === '1' ? cellInfo.data.invoiceNo : '' }}
                  </template>

                  <DxColumn data-field="shipNo" caption="Ship No" width="10%" alignment="center" :allow-editing="false" />

                  <DxColumn data-field="delyNo" caption="Delivery No" width="14%" alignment="center" :allow-editing="false" />

                  <DxColumn data-field="delyQty" caption="Items" width="7%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />

                  <DxColumn data-field="delyAmt" caption="Amount(WON/VND)" width="15%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"
                                        header-cell-template="amtWonVndHeaderTmpl" />
                  <template #amtWonVndHeaderTmpl>
                    <fragment>
                      Amount<br>(WON/VND)
                    </fragment>
                  </template>

                  <DxColumn data-field="whAmtUsd" caption="Amount(USD)" width="15%" alignment="right" :allow-editing="false" data-type="number" format="#,##0.00"
                                        header-cell-template="amtUsdHeaderTmpl" />
                  <template #amtUsdHeaderTmpl>
                    <fragment>
                      Amount<br>(USD)
                    </fragment>
                  </template>

                  <DxColumn data-field="delyWgt" caption="Weight" width="13%" alignment="right" :allow-editing="false"  data-type="number" format="#,##0.000"/>

                  <DxColumn data-field="whYn" caption="W/H" width="7%" alignment="center" :allow-editing="false"
                                        cell-template="whYnCellTmpl" />
                  <template #whYnCellTmpl="{ data: cellInfo }">
                    <template v-if="cellInfo.data.whYn === 'Y'">
                      <v-icon small class="mt-n1" color="blue" >
                        mdi-checkbox-marked-circle
                      </v-icon>
                    </template>
                    <template v-else>
                      {{ cellInfo.data.whYn }}
                    </template>
                  </template>
                </DxDataGrid>
              </v-col>

              <v-col cols="7" class="pl-1">
                <v-row dense class="form-layout">
                  <v-col cols="12" class="pa-0">
                    <v-row no-gutters>
                      <v-col cols="1" class="pa-2 d-flex align-center formHeader">
                        <span class="pl-3">Origin</span>
                      </v-col>
                      <v-col cols="11" class="pa-2 d-flex align-center formText">
                        <span class="pr-1">
                          Invoice No :
                        </span>
                        <div class="v-text-field__invoice-no">
                          <v-text-field 
                            class="text-center"
                            v-model="oldInvoiceNo" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </div>

                        <span class="ml-4 pr-1">
                          Delivery No :
                        </span>
                        <div class="v-text-field__dely-no">
                          <v-text-field
                            class="text-center"
                            v-model="delyNo" 
                            dense 
                            outlined 
                            hide-details="auto"
                            readonly
                          />
                        </div>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="1" class="pa-2 d-flex align-center formHeader">
                        <span class="pl-5">
                          New
                        </span>
                      </v-col>
                      <v-col cols="11" class="pa-2 d-flex align-center formText new-text">
                        <span class="pr-1">
                          Invoice No :
                        </span>
                        <div class="v-text-field__invoice-no">
                          <v-text-field 
                            v-model="invoiceNo" 
                            dense
                            outlined
                            hide-details="auto"
                            maxLength="16"
                          />
                        </div>
                        <i-button :text="'Change Invoice No'" :isCustom="true" :icon="'change'" role="btnChangeInvoiceNo" class="pl-2" @click="btnChangeInvoiceNo" />
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="12" class="pa-2 formHeader invoice-amount-text">
                        <span class="px-3">
                          Invoice Amount :
                        </span>
                        <span>
                          {{ invAmt }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="pt-1" style="height: calc(100% - 136px);">
                  <v-col>
                    <DxDataGrid
                      id="epms5070Ref2"
                      :ref="epms5070Ref2"
                      :data-source="dataList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared2"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxColumn data-field="delySeq" caption="No" width="5%" alignment="center" :allow-editing="false" />

                      <DxColumn data-field="shipNo" caption="Ship No" width="7%" alignment="center" :allow-editing="false" />

                      <DxColumn data-field="porNo" caption="POR No" width="10%" alignment="center" :allow-editing="false"
                                            cell-template="porNoCellTmpl" />
                      <template #porNoCellTmpl="{ data: cellInfo }">
                        {{ `${cellInfo.data.porNo}-${cellInfo.data.porSeq}` }}
                      </template>

                      <DxColumn data-field="mact" caption="Activity & Serial No" width="12%" alignment="center" :allow-editing="false"
                                            header-cell-template="actSerNoHeaderTmpl"
                                            cell-template="mactCellTmpl" />
                      <template #actSerNoHeaderTmpl>
                        <fragment>
                          Activity &<br>Serial No
                        </fragment>
                      </template>
                      <template #mactCellTmpl="{ data: cellInfo }">
                        {{ `${cellInfo.data.mact}-${cellInfo.data.bomSerno}` }}
                      </template>

                      <DxColumn data-field="matlSpec" caption="Material Specification" alignment="left" :allow-editing="false" />

                      <DxColumn data-field="delyQty" caption="Qty" width="7%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />

                      <DxColumn data-field="delyAmt" caption="Amount" width="11%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />

                      <DxColumn data-field="whYn" caption="W/H" width="5%" alignment="center" :allow-editing="false"
                                            cell-template="whYnCellTmpl" />
                      <template #whYnCellTmpl="{ data: cellInfo }">
                        <template v-if="cellInfo.data.whYn === 'Y'">
                          <v-icon small class="mt-n1" color="blue" >
                            mdi-checkbox-marked-circle
                          </v-icon>
                        </template>
                        <template v-else>
                          {{ cellInfo.data.whYn }}
                        </template>
                      </template>

                      <DxSummary>
                        <DxTotalItem column="delySeq" summary-type="count" display-format="TOTAL" />
                        <DxTotalItem column="delyQty" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="delyAmt" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import iButton from '@/components/common/iButton'
import notify from 'devextreme/ui/notify'
import { getDateFormat, getLastDate2, getNumComma, trim } from '@/utils/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getShipNoList1 } from '@/api/view/hip/common/common.js'
import { epms5070List, epms5071List, epms5070Save, epms5070Xls, epms5070XlsNew } from '@/api/view/hip/90/epms5070'
import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms5070',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      useBtnList: ['btnRetrieve', 'btnContract', 'btnMaterialList', 'btnInvoice', 'btnPackingList', 'btnInvPackList', 'btnToExcel', 'btnToExcelNew'],
      customBtnList: [
        { id: 'btnContract', text: 'Contract', icon: 'print' },
        { id: 'btnMaterialList', text: 'Material List', icon: 'print' },
        { id: 'btnInvoice', text: 'Invoice', icon: 'print' },
        { id: 'btnPackingList', text: 'Packing List', icon: 'print' },
        { id: 'btnInvPackList', text: 'Inv. & Pack.List', icon: 'print' },
        { id: 'btnToExcel', text: 'To Excel', icon: 'excel' },
        { id: 'btnToExcelNew', text: 'To Excel New', icon: 'excel' }
      ],
      epms5070Ref: 'epms5070Ref',
      epms5070Ref2: 'epms5070Ref2',
      dataList: [],
      dataList2: [],
      selectShipNo: null,
      shipNoList: [],
      selectPayDiv: null,
      payDivList: [],
      selectWhDiv: null,
      whDivList: [],
      stDte: '',
      edDte: '',
      oldInvoiceNo: '',
      invoiceNo: '',
      delyNo: '',
      invAmt: '',
      mergeEls: {}
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms5070Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epms5070Ref2)
    }
  },
  methods: {
    init() {
      this.stDte = getLastDate2('m', { mm: -2 })
      this.edDte = getLastDate2('m', { mm: 2 })

      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)
    },
    clearGrid() {
      this.gridInstance.option('focusedRowIndex', -1)
      this.gridInstance.clearSelection()
      this.dataList = []
      this.oldInvoiceNo = ''
      this.delyNo = ''
    },
    clearGrid2() {
      this.invoiceNo = ''
      this.grid2Instance.clearSelection()
      this.dataList2 = []
      this.invAmt = ''
    },
    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }

      await getShipNoList1(param).then(async res => {
        // console.log('getShipNoList1Res', res)

        this.shipNoList = res.list
        this.shipNoList.unshift({
          shipNo: ''
        })
        this.selectShipNo = this.shipNoList[0]
      })
    },
    async getPayDivList() {
      const param = {
        code: '',
        codegr: '',
        prtCode: 'PAY_DIV',
        userFlag: 'Y'
      }

      await getCmChildCode(param).then(res => {
        this.payDivList = res.list
        this.selectPayDiv = this.payDivList[0]
      })
    },
    async getWhDivList() {
      const param = {
        code: '',
        codegr: '',
        prtCode: 'WH_DIV',
        userFlag: 'Y'
      }

      await getCmChildCode(param).then(res => {
        this.whDivList = res.list
        this.selectWhDiv = this.whDivList[0]
      })
    },
    async btnRetrieve(detail = true) {
      this.clearGrid()
      this.clearGrid2()

      const param = {
        makerCd: this.makerCd,
        stDte: this.stDte,
        edDte: this.edDte,
        shipNo: this.selectShipNo.shipNo,
        whDiv: this.selectWhDiv.code,
        payDiv: this.selectPayDiv.code
      }

      // console.log('epms5070List Param', param)
      
      this.openLoading()
      await epms5070List(param).then(res => {
        // console.log('epms5070List Res', res)

        let data = res.list

        let id = 0
        data.forEach(row => {
          id++
          row.id = id
        })

        this.dataList = data

        if(this.dataList.length > 0 && detail) {
          this.gridInstance.option('focusedRowIndex', 0)
          this.oldInvoiceNo = this.dataList[0].invoiceNo
          this.delyNo = this.dataList[0].delyNo
          this.getDetail()
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    getDetail() {
      this.clearGrid2()

      const param = {
        makerCd: this.makerCd,
        invoiceNo: this.oldInvoiceNo,
        delyNo: this.delyNo
      }

      this.openLoading()
      epms5071List(param).then(res => {
        // console.log('epms5071List Res', res)

        this.invAmt = res.invAmt

        let data = res.list

        let id = 0
        data.forEach(row => {
          id++
          row.id = id
        })

        this.dataList2 = data
      }).finally(() => {
        this.endLoading()
      })
    },
    cellClick(e) {
      // console.log('cellClick Event', e)

      if(e.rowType === 'data') {
        if(e.rowIndex >= 0) {
          this.oldInvoiceNo = e.data.invoiceNo
          this.delyNo = e.data.delyNo
          this.getDetail()
        }
      }
    },
    cellPrepared(e) {
      // if (e.rowType == 'data') {
      //   if (e.rowIndex > 0 && e.column.command != 'edit') {
      //     if(e.column.dataField === 'invoiceNo') {
      //       if (e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value) {
      //         if (e.component.cellValue(e.rowIndex - 1, e.column.dataField)) {
      //           var prev = this.mergeEls[e.rowIndex - 1][e.column.dataField]
      //           if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
      //           this.mergeEls[e.rowIndex][e.column.dataField] = prev
      //           if (prev) {
      //             e.cellElement.style.display = 'none'
      //             var span = prev.getAttribute('rowspan')
      //             if (span)
      //               prev.setAttribute('rowspan', Number(span) + 1)
      //             else
      //               prev.setAttribute('rowspan', 2)
      //           }
      //         }
      //         else
      //         {
      //           if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
      //           this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
      //         }
      //       }
      //       else {
      //         if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
      //         this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
      //       }
      //     }
      //   }
      //   else {
      //     if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
      //     this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
      //   }
      // }
    },
    cellPrepared2(e) {
      if(e.rowType === 'totalFooter') {
        // console.log('cellPrepared2 Event', e)

        if(e.column.dataField === 'delySeq') {
          e.cellElement.setAttribute('colspan', 5)
        } else if(e.column.dataField === 'shipNo' || e.column.dataField === 'porNo'
                    || e.column.dataField === 'mact' || e.column.dataField === 'matlSpec') {
          e.cellElement.style.display = 'none'
        }
      }
    },
    btnContract() {
      let param = {
        as_invoice_no: this.oldInvoiceNo,
        as_maker_cd: this.$store.state.user.makerCd,        
        fileName: 'epms5010miboo1.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnMaterialList() {
      let param = {
        as_invoice_no: this.oldInvoiceNo,
        as_maker_cd: this.$store.state.user.makerCd,
        fileName: 'epms5010miboo2.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnInvoice() {
      let param = {
        as_invoice_no: this.oldInvoiceNo,
        as_maker_cd: this.$store.state.user.makerCd,
        as_pay_div : this.selectPayDiv.code,
        fileName: 'epms5010miboo3.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnPackingList() {
      let param = {
        as_invoice_no: this.oldInvoiceNo,
        as_maker_cd: this.$store.state.user.makerCd,
        fileName: 'epms5010miboo4.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnInvPackList() {
      let param = {
        as_invoice_no: this.oldInvoiceNo,
        as_maker_cd: this.$store.state.user.makerCd,
        fileName: 'epms5010miboo5.jrxml'
      }

      this.openLoading()
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnToExcel() {
      const invoiceNo = this.oldInvoiceNo

      if(!invoiceNo) {
        this.vToastify(this.$t('Select Invoice No.'), 'warn')
        return
      }

      const param = {
        invoiceNo: invoiceNo,
        makerCd: this.makerCd
      }

      this.openLoading()
      epms5070Xls(param).finally(() => {
        this.endLoading()
      })
    },
    btnToExcelNew() {
      const invoiceNo = this.oldInvoiceNo

      if(!invoiceNo) {
        this.vToastify(this.$t('Select Invoice No.'), 'warn')
        return
      }

      const param = {
        invoiceNo: invoiceNo,
        makerCd: this.makerCd
      }

      this.openLoading()
      epms5070XlsNew(param).finally(() => {
        this.endLoading()
      })
    },
    btnChangeInvoiceNo() {
      const oldInvoiceNo = this.oldInvoiceNo
      const newInvoiceNo = trim(this.invoiceNo).toUpperCase()

      if(!newInvoiceNo) {
        this.vToastify(this.$t('Input new invoice no.'), 'warn')
        return
      }

      if(oldInvoiceNo === newInvoiceNo) {
        this.vToastify(this.$t('New invoice no is same with old invoice no.'), 'warn')
        return
      }
      
      this.vToastifyPrompt(
        this.$t('Do you want to change invoice no?'),
        'info',
        current => {
          // console.log('current', current)

          const oldDelyNo = this.delyNo
          const param = {
            makerCd: this.makerCd,
            userId: this.userId,
            invoiceNo: newInvoiceNo,
            oldInvoiceNo: oldInvoiceNo,
            delyNo: oldDelyNo
          }

          // console.log('epms5070Save param', param)

          this.openLoading()
          epms5070Save(param).then(async res => {
            const msg = res.body

            if(msg === 'OK') {
              notify(this.$t('Change Invoice No is completed.'), 'success', 3000)
              
              await this.btnRetrieve(false)

              if(this.dataList.length > 0) {
                const idx = this.$_.findIndex(this.dataList, { invoiceNo: newInvoiceNo, delyNo: oldDelyNo })

                // console.log('idx', idx)
                
                if(idx > -1) {
                  this.gridInstance.option('focusedRowIndex', idx)
                  this.oldInvoiceNo = this.dataList[idx].invoiceNo
                  this.delyNo = this.dataList[idx].delyNo
                  this.getDetail()
                }
              }
            } else {
              this.vToastify(this.$t(msg), 'warn')
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    totalFormat(e) {
      const result = getNumComma(Number(e.value), 2)
      return result
    }
  },
  async mounted() {
    this.init()
    await this.getShipNoList()
    await this.getPayDivList()
    await this.getWhDivList()
    await this.btnRetrieve()
  }
}
</script>

<style lang="scss" scoped>
.epms5070-main {
  .form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;
    
    .row {
      border-width: 0 0 1px 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }

    .col {
      border-width: 0 1px 0 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }
  }

  .formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
  }

  .new-text {
    background: #00FFF0;
  }

  .invoice-amount-text {
    background: #0FF330;
  }

  .formText, .invoice-amount-text {
    color: #000000;
  }

  .v-text-field__invoice-no {
    width: 135px;
  }

  .v-text-field__dely-no {
    width: 100px;
  }

  #epms5070Ref2 {
    height: 100vh;
    max-height: calc(100vh - 354px);
  }
}
</style>
